import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, AbstractControl } from '@angular/forms';
import { AuthService } from 'src/app/auth/auth.service';
import { Router } from '@angular/router';
import { MainService } from 'src/app/services/main.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  loginForm: FormGroup | any;

  constructor(private rest : AuthService ,
    private serv : MainService,
    private router: Router){}

  ngOnInit(){
    this.loginForm = new FormGroup({
      email: new FormControl("", [Validators.required,Validators.email]),
      password: new FormControl("", [Validators.required]),
    })
  }


  login(){
    if(this.loginForm.valid){
      console.log(this.loginForm.value)
      this.rest.login(this.loginForm.value).subscribe((res :any) => {
        console.log(res)
        this.rest.setLoginStatus(true);
        localStorage.setItem("acc_token",res.access_token)
        this.serv.SuccessToast("Login Success")
        this.router.navigate(['pages/Dashboard']);
      }, (err:any) => {
        console.log(err)
        this.serv.erorrToast("Pleas check Email or Password")
      })
    }

  }
 
  get loginFormControl() {
    return this.loginForm.controls;
  }

}
